import { lineBreakHandler, lineBreakMatcher, SoftBreak } from './soft_break';
import {
  headerShortcutHandler,
  redoChange,
  TOOLBAR,
  undoChange,
} from './toolbar';

// remove color styling from the pasted text
const attributesToDelete = ['color', 'background'];
const sanitizeClipboardMatcher = (_, delta) => {
  delta.ops = delta.ops.map((op) => {
    const attributes = { ...op.attributes };
    attributesToDelete.forEach((key) => delete attributes[key]);
    return { ...op, attributes };
  });
  return delta;
};

// this const will be used as the modules prop for the
// react-quill component
export const generateModules = () => ({
  toolbar: {
    container: TOOLBAR,
    handlers: {
      undo: undoChange,
      redo: redoChange,
      shortcuts: () => {}, // suppressing the warnings
    },
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
  clipboard: {
    // if true, quill would try to 'refactor' the html which leads us
    // to risk of falling into infinite loop given our lineBreakMatcher
    // and parse prop on EditorField component.
    // related to the issue https://github.com/gohiring/mpt/issues/1858
    // exapmle of problematic html:
    //  1. <h3>Title</h3><p><br /></p><h2>Subtitle</h2>
    //  2. <h3>Title</h3><p> <br /> </p><h2>Subtitle</h2>
    //  3. <h3>Title</h3><p>Text<br /></p><h2>Subtitle</h2>
    //  these would cause an infinite loop
    matchVisual: false,
    matchers: [
      ['BR', lineBreakMatcher],
      [Node.ELEMENT_NODE, sanitizeClipboardMatcher],
    ],
  },
  keyboard: {
    bindings: {
      linebreak: {
        key: 'Enter',
        shiftKey: true,
        handler: lineBreakHandler,
      },
      // ctrl + H => text to heading
      headerShortcut: {
        key: 'H',
        shortKey: true,
        handler: headerShortcutHandler,
      },
      // ctrl + Y => redo
      redoShortcut: {
        key: 'Y',
        shortKey: true,
        handler: redoChange,
      },
    },
  },
});

// translations for internal quill components
export const generateTranslations = ({ translate }) => ({
  linkLabel: translate('.addLinkLabel'),
  visitLink: translate('.visitLink'),
  linkSave: translate('app.actions.save'),
  linkEdit: translate('app.actions.edit'),
  linkRemove: translate('app.actions.delete'),
});

export const setup = (Quill) => {
  Quill.register(SoftBreak);
};
